<div>
  <!--Drop Down To Select List of Countries-->
  <div class="row mt-5">
    <div class="col-md-6 mx-auto text-center">
      <h2 class="heading-black">Choose a Country</h2>
      <p class="text-muted lead">For more insights</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 mx-auto text-center">
      <select class="form-control" [(ngModel)]="sepcificCountry">
        <option *ngFor="let country of countryList" [value]="country">{{country}}</option>
      </select><br>
      <button class="btn btn-primary" (click)="getInsightsForCard()">Get Info</button>
    </div>
  </div>
</div>
<br>
<div class="container border p-5" *ngIf="specificCountryData!=null">
  <!--Display the Info Here-->
  <h1 class="text-center">{{sepcificCountry}}</h1>
  <div class="row">
    <div class="col-sm-3">
      <div class="card shadow my-3">
        <div class="card-header text-dark h6">Total Cases</div>
        <div class="card-body text-info">
          <h1 class="card-title">{{specificCountryData.cases}}</h1>
          <h3>Total number of cases till today</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="card shadow my-3">
        <div class="card-header text-dark h6">Recovered</div>
        <div class="card-body text-success">
          <h1 class="card-title">{{specificCountryData.recovered}}</h1>
          <h3>Total number of recovered cases till today</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="card shadow my-3">
        <div class="card-header text-dark h6">Deaths</div>
        <div class="card-body text-danger">
          <h1 class="card-title">{{specificCountryData.deaths}}</h1>
          <h3>Total number of deaths till today</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="card shadow my-3">
        <div class="card-header text-dark h6">Active</div>
        <div class="card-body text-secondary">
          <h1 class="card-title">{{specificCountryData.active}}</h1>
          <h3>Total number of active cases up until now</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-6">
      <div>
        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
          [legend]="barChartLegend" [chartType]="barChartType">
        </canvas>
      </div>
    </div>
    <div class="col-md-6">
      <div>
        <canvas baseChart [datasets]="barChartData2" [labels]="barChartLabels2" [options]="barChartOptions"
          [legend]="barChartLegend2" [chartType]="barChartType2">
        </canvas>
      </div>
    </div>
  </div>
  <div *ngIf="historicalData==true" class="row justify-content-center mt-5">
    <div class="col-md-6">
      <div>
        <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="barChartOptions"
          [legend]="lineChartLegend" [chartType]="lineChartType">
        </canvas>
      </div>
    </div>
  </div>
</div>
<br>
<div class="container-fluid">
  <table class="table table-hover table-striped table-bordered" id="myTable">
    <thead class="thead-dark">
      <tr>
        <th *ngFor="let heading of displayedColumns">{{heading}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of theCovidData | orderBy: 'cases': 'reverse'">
        <td>{{data.country}}</td>
        <td>{{data.cases}}</td>
        <td>{{data.todayCases}}</td>
        <td>{{data.deaths}}</td>
        <td>{{data.todayDeaths}}</td>
        <td>{{data.recovered}}</td>
        <td>{{data.active}}</td>
        <td>{{data.critical}}</td>
        <td>{{data.casesPerOneMillion}}</td>
        <td>{{data.deathsPerOneMillion}}</td>
        <td>{{data.tests}}</td>
        <td>{{data.testsPerOneMillion}}</td>
      </tr>
    </tbody>
  </table>
</div>